import Footer from './footer'

export {Footer}

export default Footer
